import { render, staticRenderFns } from "./MeldSTSScore.vue?vue&type=template&id=0cd681c4"
import script from "./MeldSTSScore.vue?vue&type=script&lang=js"
export * from "./MeldSTSScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports